export default "__VITE_ASSET__BXGiIZnV__"